import "./ToggleButton.scss";
import { clsx } from "clsx";

export const ToggleButton = (props: {
  label?: string;
  checked: boolean;
  onChange: (state: boolean) => void;
  className?: string;
}): JSX.Element => {
  const onChange = () => {
    props.onChange(!props.checked);
  };

  const className = props.className ?? "";

  return (
    <div className={clsx("ToggleButton", { [className]: true })}>
      {props.label && <label>{props.label}</label>}

      <div className={clsx("ToggleButton-CheckboxWrapper", { "ToggleButton-Checked": props.checked })}>
        <div className="ToggleButton-Checkbox">
          <input className="ToggleButton-Input" type="checkbox" onChange={onChange} checked={props.checked}/>
          <div className="ToggleButton-Thumb"></div>
        </div>
      </div>
    </div>
  );
};
